<template>
  <div id="app">
    <shared-chat v-if="sharedThreadId" :sharedThreadId="sharedThreadId" />
    <user-auth v-else-if="!isAuthorized" @authorized="onAuthorized" />
    <chat-view v-else :userName="userName" :displayUserName="getDisplayUserName()" />
  </div>
</template>

<script>
import chatView from './components/chat-view.vue'
import userAuth from './components/user-auth.vue'
import sharedChat from './components/shared-chat.vue'

export default {
  name: 'App',
  components: {
    sharedChat,
    chatView,
    userAuth
  },
  data() {
    return {
      isAuthorized: false,
      userName: localStorage.getItem('USER_NAME'),
      displayUser: false,
      allowLogout: false,
      sharedThreadId: null
    }
  },
  created() {
    const url = new URL(window.location.href);
    const uname = url.searchParams.get('uname');

    this.sharedThreadId = url.searchParams.get('sharedThreadId');
    if(this.sharedThreadId) {
      return;
    }

    if (uname && uname.trim().length > 0) {
      localStorage.setItem('USER_NAME', uname.trim());
      this.isAuthorized = true;

      if(this.userName !== uname.trim()) {
        window.location.reload();
      }

      return;
    }

    if (this.userName && this.userName.length > 2) {
      this.isAuthorized = true;
    }
  },
  // watch: {
  //   isAuthorized(newValue) {
  //   }
  // },
  methods: {
    onAuthorized() {
      this.userName = localStorage.getItem('USER_NAME');
      this.isAuthorized = true;
      window.location.reload();
    },
    getDisplayUserName() {
      const stored = localStorage.getItem('USER_NAME') || '';
      if (stored.startsWith('guest-')) {
        return 'guest';
      }
      return stored;
  }
  },
  mounted() {
    const waitForJivo = setInterval(() => {
      if (window.JivoApi && typeof window.JivoApi.setCustomButton === 'function') {
        window.JivoApi.setCustomButton(true); // 💥 отключает встроенную кнопку
        clearInterval(waitForJivo);
      }
    }, 300);
  }
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.userName {
  padding-left: 5px;
  color: #989b9e;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue